<telxl-panel [hover]="true" cardClass="mt-2" bodyClass="pt-1 pb-1">
    <ng-template #cardBody>
        <div class="d-flex align-items-center">
            <div class="left">
                <div
                    class="d-flex font-lg weight-heavy justify-content-between align-items-center"
                >
                    <div>
                        {{ upload().filename }} ({{ upload().current }}/{{
                            upload().total
                        }})
                    </div>
                </div>

                <div class="font-sm fixed-margin">
                    {{ timeRemaining() }}
                </div>
                <div class="d-flex w-100 align-items-center">
                    <div class="w-100 me-2">
                        <ngb-progressbar
                            height="0.5rem"
                            type="primary"
                            [value]="upload().progress"
                            [striped]="true"
                        />
                    </div>
                    <div class="font-sm">{{ upload().progress }}%</div>
                </div>
            </div>
        </div>
    </ng-template>
</telxl-panel>
